export const rootElementId = 'home-page-upsell-card-container';

export const translation = {
  common: [],
  feature: 'Feature.ContactUpsell'
};
